exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".CardBox {\n  flex: 0 1 calc(33% - 30px);\n  position: relative; }\n  .CardBox:hover, .CardBox:active {\n    z-index: 10000; }\n  @media (max-width: 1500px) {\n    .CardBox {\n      flex-basis: calc(50% - 30px); } }\n  @media (max-width: 1200px) {\n    .CardBox {\n      flex-basis: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/RLX/Forms/CardBox/CardBox.scss
// module id = 387
// module chunks = 0